module.exports = __webpack_public_path__ + "img/white.7e8a98ac.png";